// ==============================================
// ==================Import======================
// ==============================================

// ==================Library===================
import PropTypes from 'prop-types';

// ==================Style&IMG===================
import './style.scss';

function NodeInfoArray({ header, content }) {
  return (
    <div className="nodeList--container">
      <table id="nodeList">
        <thead>
          <tr>
            <td>{header[0].value}</td>
            <td>{header[1].value}</td>
          </tr>
        </thead>
        <tbody>
          {content.map((el) => (
            <tr key={el.id}>
              <td><a className="node" href={el.value.Link}>{el.value.Name}</a></td>
              <td>{el.value.Country}</td>
            </tr>
          ))}

        </tbody>
      </table>
    </div>
  );
}

NodeInfoArray.propTypes = {
  header: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
    }),
  ).isRequired,
  content: PropTypes.arrayOf(
    PropTypes.shape({}),
  ).isRequired,
};

export default NodeInfoArray;
